import { Button, Stack } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';
import ShareCollectionButton from '@components/ShareButton/ShareCollectionButton';

import { AVG_HEART_RATE } from '@constants/fhir';

import { useHealthChart } from '@hooks/useHealthChart';
import { useSession } from '@hooks/useSession';

import { SHARED_RESOURCE_OBSERVATION_MAP } from '@models/shared_resource';
import { TrackerType } from '@models/vital-sign';
import { HEALTH_TRACKER_MAP } from '@models/vital-sign';

import { ShareType } from 'generated/types';

const messages = defineMessages({
  editParameters: {
    id: 'insights.header.editParameters',
    defaultMessage: 'Edit Parameters',
  },
});

export default function HealthTrackerActions() {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile, isPractitioner },
  } = useSession();
  const { category, code, normalRange } = useHealthChart();
  const { backRoute } = HEALTH_TRACKER_MAP[category];

  let shareType: ShareType | undefined;
  switch (true) {
    case code === AVG_HEART_RATE && category === TrackerType.Fitness:
      shareType = ShareType.DailyStats_averageHeartRate;
      break;
    case code === AVG_HEART_RATE && category === TrackerType.Sleep:
      shareType = ShareType.Sleep_averageHeartRate;
      break;
    default:
      shareType =
        code in SHARED_RESOURCE_OBSERVATION_MAP
          ? SHARED_RESOURCE_OBSERVATION_MAP[code]
          : undefined;
      break;
  }

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="flex-end"
      spacing={1}
      sx={{
        width: '100%',
      }}
    >
      {isPractitioner && normalRange && (
        <Button
          onClick={() => {
            navigate(`${backRoute}${code}/parameters`);
          }}
          size="small"
          startIcon={<Icon name="pencil" type="fas" />}
          sx={{
            borderRadius: '29px',
            border: 'none',
            color: 'primary.contrastText',
          }}
          variant="text"
        >
          {formatMessage(messages.editParameters)}
        </Button>
      )}
      {activeProfile?.vitall_patient_id && shareType && (
        <ShareCollectionButton
          color="primary.contrastText"
          share_type={shareType}
        />
      )}
    </Stack>
  );
}
